import { makeStyles, shorthands } from '@fluentui/react-components';

const getAssetListBarCarouselStyle = makeStyles({
  subHeading: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 600,
    lineHeight: '26px',
    fontFamily: 'Segoe UI',
    fontSize: '20px',
    textAlign: 'left',
    marginTop: '30px',
  },
  paragraph: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    textAlign: 'left',
  },
  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    position: 'relative',
    width: '100%',
  },
  btnWrapper: {
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    zIndex: 1,
    ...shorthands.borderRadius('50%'),
    boxShadow: '0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.10), 0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13)',
    backgroundColor: '#ffffff',
  },
  leftWrapper: {
    left: '-16px',
  },
  rightWrapper: {
    right: '-16px',
  },
  leftBtn: {
    cursor: 'pointer',
    color: '#0078d4',
  },
  rightBtn: {
    cursor: 'pointer',
    color: '#0078d4',
  },
  overlay: {
    position: 'absolute',
    width: '24px',
    height: '230px',
  },
  leftOverlay: {
    left: 0,
    backgroundImage: 'linear-gradient(90deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%)',
  },
  rightOverlay: {
    right: 0,
    backgroundImage: 'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255) 100%)',
  },
  slider: {
    display: 'flex',
    flexDirection: 'row',
    scrollBehavior: 'smooth',
    whiteSpace: 'nowrap',
    flexGrow: 1,
    overflowX: 'hidden',
    pointerEvents: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
    paddingBottom: '10px',
    paddingTop: '8px',
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },
});

export default getAssetListBarCarouselStyle;
